import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import useSWR from 'swr';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { ADMIN_ACCESS_TOKEN_KEY } from '../../../App';
import { Body } from '@components/templates';
import { Filters, Worklist, Pagination } from '@components/organisms';
import { DEFAULT_COUNT_PER_PAGE, DEFAULT_CURRENT_PAGE } from '@components/organisms/Table/Pagination';
import InfoPage from '@pages/License/Info';

const AdminLogPage = () => {
  const [accessToken, setAccessToken] = useState('');
  const [valueState, setValueState] = useState({
    searchKey: '',
    searchKeyword: '',
    searchDateType: '',
    selectedStaticRange: '',
    dateRange: { startDate: '', endDate: '' },
  });
  const [pageConditionsValue, setPageConditionsValue] = useState({
    countPerPage: DEFAULT_COUNT_PER_PAGE,
    currentPage: DEFAULT_CURRENT_PAGE,
    totalCount: 1,
    'order.name': 'id',
    'order.sort': 'DESC',
  });
  const { countPerPage, currentPage } = pageConditionsValue;
  const { searchKey, searchKeyword, dateRange } = valueState;

  useEffect(() => {
    const newToken = localStorage.getItem(ADMIN_ACCESS_TOKEN_KEY);
    if (newToken) {
      setAccessToken(newToken);
    }
  }, []);

  useEffect(() => {
    if (valueState)
      setPageConditionsValue((prev) => ({
        ...prev,
        currentPage: DEFAULT_CURRENT_PAGE,
      }));
  }, [valueState]);

  const url = `api/log/admin/history?countPerPage=${countPerPage}&currentPage=${currentPage}&searchType=${
    searchKey || ''
  }&searchValue=${searchKeyword || ''}&fromDate=${dateRange.startDate || ''}&toDate=${dateRange.endDate || ''}`;

  const { data, error } = useSWR(!!accessToken.length ? [{ url, accessToken }] : null);

  if (error) {
    return <div>failed to load</div>;
  }
  if (!data?.result) {
    return <div>error</div>;
  }

  let adminLogs: any[] = [];
  if (data) {
    if (data.code === 'UNAUTHORIZED') return <Navigate to={'/'} replace={true} />;

    if (data.code === '200') {
      const { countPerPage, currentPage, totalCount } = data.result.condition;
      const startNo = totalCount - (currentPage - 1) * countPerPage;
      data.result.results.map((item: any, index: number) => {
        adminLogs.push({
          ...item,
          no: startNo - index,
          name: `**** ${item.firstName}`,
        });
      });
    }
  }
  return (
    <>
      <label>Administrator Log (Recent Access Data of Admin)</label>
      <AdminLogBody data-page-type={'table-only'}>
        <Filters
          filterKey={'log'}
          searchConditions={valueState}
          setSearchConditions={setValueState}
          styles={DataRangeFirstStyle}
        />
        <Worklist
          headers={[
            { label: 'No', data_label: 'no' },
            { label: 'Company Id', data_label: 'companyId' },
            { label: 'Menu', data_label: 'menu' },
            { label: 'User ID', data_label: 'userId' },
            { label: 'Name', data_label: 'name' },
            { label: 'IP Address', data_label: 'ipAddress' },
            { label: 'Privacy', data_label: 'privacy' },
            { label: 'Method', data_label: 'action' },
            { label: 'Url', data_label: 'url' },
            { label: 'Created Datetime', data_label: 'createdDatetime' },
          ]}
          data={{ dataArray: adminLogs }}
          customColumn={{
            privacy: (row) => <>{row.privacy ? '\u2713' : ''} </>,
          }}
        />
        <Pagination conditions={data.result?.condition ?? pageConditionsValue} setConditions={setPageConditionsValue} />
      </AdminLogBody>
    </>
  );
};

const AdminLogBody = styled(Body)`
  flex-direction: column;
  justify-content: flex-start;
  text-align: left;
  //min-width: 920px;

  & > div:nth-of-type(1) {
    margin-left: 0;
  }
`;

export const DataRangeFirstStyle = css`
  & > div:nth-of-type(1) {
    flex-direction: row-reverse;
  }
`;
export default AdminLogPage;
